import React, { useEffect, useState } from 'react';
import { opportunityWatchService } from '../../../services/opportunityWatchService';
import { Button } from '../../ui/Button';
import { FindingFollowUp } from './FindingFollowUp';

export const WatchFindings = ({ userId, watch, contacts, onContactAdded, onFlash, onChanged }) => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const [creatingId, setCreatingId] = useState(null);

  const load = () => {
    opportunityWatchService.findings(watch.id).then(setItems).catch((e) => setError(e.message));
  };
  useEffect(load, [watch.id]);

  const mark = async (id, state) => {
    try {
      await opportunityWatchService.setFindingState(id, state, watch.id);
      load();
      onChanged?.();
    } catch (e) {
      onFlash('error', e.message);
    }
  };

  if (error) return <p className="mt-3 text-xs text-red-600">{error}</p>;
  if (!items) return <p className="mt-3 text-xs text-slate-500">Loading history…</p>;
  if (items.length === 0) return <p className="mt-3 text-xs text-slate-500">No findings yet. Meetoi only records information it can link to a real source.</p>;

  return (
    <div className="mt-3 space-y-3">
      {items.map((f) => (
        <div key={f.id} className="rounded-xl border border-slate-200 bg-slate-50 p-3">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-semibold text-slate-900">{f.title}</span>
            <span className={`rounded px-1.5 py-0.5 text-[10px] font-bold uppercase ${f.classification === 'confirmed' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
              {f.classification === 'confirmed' ? 'Confirmed' : 'Unconfirmed'}
            </span>
            {f.state === 'new' && <span className="rounded bg-blue-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-blue-700">New</span>}
          </div>
          <p className="mt-1 text-sm text-slate-700">{f.summary}</p>
          {(f.event_date || f.deadline_date) && (
            <p className="mt-1 text-xs text-slate-600">
              {f.event_date && `Date: ${f.event_date}`} {f.deadline_date && `· Deadline: ${f.deadline_date}`}
            </p>
          )}
          {f.quote && <p className="mt-1 text-xs italic text-slate-500">“{f.quote}”{f.quote_verified ? ' (found on the page)' : ''}</p>}
          <p className="mt-1 break-all text-xs">
            Source:{' '}
            <a href={f.source_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">{f.source_domain}</a>
            {f.is_official ? ' · official source' : ''} · {new Date(f.created_at).toLocaleDateString()}
          </p>
          <div className="mt-2 flex flex-wrap gap-2">
            {f.classification === 'confirmed' && (
              <Button size="sm" onClick={() => setCreatingId(creatingId === f.id ? null : f.id)}>Create follow-up</Button>
            )}
            {f.state === 'new' && <Button size="sm" variant="secondary" onClick={() => mark(f.id, 'reviewed')}>Mark reviewed</Button>}
            <Button size="sm" variant="ghost" onClick={() => mark(f.id, 'dismissed')}>Dismiss</Button>
          </div>
          {creatingId === f.id && (
            <FindingFollowUp
              userId={userId}
              watch={watch}
              finding={f}
              contacts={contacts}
              onContactAdded={onContactAdded}
              onCancel={() => setCreatingId(null)}
              onSaved={() => {
                setCreatingId(null);
                mark(f.id, 'reviewed');
                onFlash('success', 'Follow-up added.');
                onChanged?.(true);
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};